import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalette = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 20C9 16.3 10.8 13 13.7 11C14.7 10.3 16.4 10.1 17 11C18 12.2 16.2 14 17 15C19 17.4 23.1 12.7 28 15C31.5 16.8 31 21.3 30.6 23C29.3 27.6 25 31 20 31C13.9 31 9 26.1 9 20Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 22C26.1046 22 27 21.1046 27 20C27 18.8954 26.1046 18 25 18C23.8954 18 23 18.8954 23 20C23 21.1046 23.8954 22 25 22Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 21C13.5523 21 14 20.5523 14 20C14 19.4477 13.5523 19 13 19C12.4477 19 12 19.4477 12 20C12 20.5523 12.4477 21 13 21Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 26C16.0523 26 16.5 25.5523 16.5 25C16.5 24.4477 16.0523 24 15.5 24C14.9477 24 14.5 24.4477 14.5 25C14.5 25.5523 14.9477 26 15.5 26Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 28C21.5523 28 22 27.5523 22 27C22 26.4477 21.5523 26 21 26C20.4477 26 20 26.4477 20 27C20 27.5523 20.4477 28 21 28Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgPalette);
export default ForwardRef;
